var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCreditCard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 16,
    viewBox: "0 0 21 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#989AAE",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 14,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 5.5h19"
  }))));
}

export default __webpack_public_path__ + "./fonts/credit-card.912ddd5787b79698b5e178a4191b65cf.svg";
export { SvgCreditCard as ReactComponent };